"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=IQueryOperationResult.js.map